var constants = {
    desktopWidth: 1366,
    tabletWidth: 768
}

module.exports = constants;